"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=opening-stock.dto.js.map